<template>
    <nav
        :class="`sticky top-${topResponsive} z-10 flex flex-col gap-0 border-b border-gray-200 bg-white ${responsiveBreakpoint}:top-${topDefault} pt-4`"
    >
        <slot></slot>
    </nav>
</template>
<script setup>
import { computed } from 'vue';

const props = defineProps({
    topDefault: {
        type: Number,
        required: true,
    },
    topResponsive: {
        type: Number,
        required: true,
    },
    responsiveBreakpoint: {
        type: String,
        required: false,
        default: 'lg',
    },
});

const topDefault = computed(() => props.topDefault);
const topResponsive = computed(() => props.topResponsive);
const responsiveBreakpoint = computed(() => props.responsiveBreakpoint);
</script>
